(function () {
  var existingController = window.__havenHeaderController;

  if (existingController && typeof existingController.destroy === 'function') {
    existingController.destroy();
  }

  var controller = {
    cleanups: [],
    destroy: function () {
      while (controller.cleanups.length) {
        controller.cleanups.pop()();
      }

      if (window.__havenHeaderController === controller) {
        window.__havenHeaderController = null;
      }
    }
  };

  window.__havenHeaderController = controller;

  function addManagedListener(target, type, handler, options) {
    if (!target || !target.addEventListener) return;
    target.addEventListener(type, handler, options);
    controller.cleanups.push(function () {
      target.removeEventListener(type, handler, options);
    });
  }

  function initHavenHeader() {
    var headerSection = document.querySelector('.section-header');
    var header = document.querySelector('.haven-header');
    var nav = header ? header.querySelector('.header__inline-menu') : null;

    if (!headerSection || !header || !nav) return;

    var brandToggle = nav.querySelector('[data-haven-brands-toggle]');
    var brandPanel = nav.querySelector('#HavenBrandQuicklinks');
    var brandsOpen = false;
    var lastScrollY = window.scrollY || 0;
    var ticking = false;
    var hidden = false;
    var scrollDirection = 0;
    var accumulatedDistance = 0;
    var transitionGuardUntil = 0;
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var HIDE_DISTANCE = 28;
    var REVEAL_DISTANCE = 18;
    var TOP_THRESHOLD = 24;
    var TRANSITION_GUARD_MS = 320;

    function setBrandsOpen(shouldOpen) {
      if (!brandToggle || !brandPanel) return;
      brandsOpen = shouldOpen;
      nav.classList.toggle('haven-header__brands-open', brandsOpen);
      brandToggle.setAttribute('aria-expanded', brandsOpen ? 'true' : 'false');
      brandPanel.setAttribute('aria-hidden', brandsOpen ? 'false' : 'true');

      if (!brandsOpen) {
        var menuDetails = brandToggle.closest('details');
        if (menuDetails) menuDetails.removeAttribute('open');
      }
    }

    function resetScrollTracking(currentScrollY) {
      lastScrollY = typeof currentScrollY === 'number' ? currentScrollY : window.scrollY || 0;
      scrollDirection = 0;
      accumulatedDistance = 0;
      transitionGuardUntil = 0;
    }

    function setHidden(shouldHide, currentTime) {
      if (hidden === shouldHide) return;
      hidden = shouldHide;
      headerSection.classList.toggle('haven-nav-hidden', hidden);
      accumulatedDistance = 0;
      scrollDirection = 0;
      transitionGuardUntil = (currentTime || performance.now()) + TRANSITION_GUARD_MS;
      if (hidden) setBrandsOpen(false);
    }

    function updateHeaderNav(currentTime) {
      var currentScrollY = window.scrollY || 0;
      var delta = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;

      if (!desktopQuery.matches) {
        setHidden(false, currentTime);
        setBrandsOpen(false);
        resetScrollTracking(currentScrollY);
        return;
      }

      if (currentScrollY <= TOP_THRESHOLD) {
        if (hidden) setHidden(false, currentTime);
        accumulatedDistance = 0;
        scrollDirection = 0;
        return;
      }

      if (currentTime < transitionGuardUntil) {
        accumulatedDistance = 0;
        scrollDirection = 0;
        return;
      }

      if (delta === 0) return;

      var direction = delta > 0 ? 1 : -1;

      if (direction !== scrollDirection) {
        scrollDirection = direction;
        accumulatedDistance = 0;
      }

      accumulatedDistance += Math.abs(delta);

      if (!hidden && direction === 1 && accumulatedDistance >= HIDE_DISTANCE) {
        setHidden(true, currentTime);
      } else if (hidden && direction === -1 && accumulatedDistance >= REVEAL_DISTANCE) {
        setHidden(false, currentTime);
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function (timestamp) {
        ticking = false;
        updateHeaderNav(timestamp);
      });
    }

    if (brandToggle && brandPanel) {
      setBrandsOpen(false);

      addManagedListener(brandToggle, 'click', function (event) {
        if (!desktopQuery.matches) return;
        event.preventDefault();
        event.stopPropagation();
        setHidden(false, performance.now());
        setBrandsOpen(!brandsOpen);
      });

      addManagedListener(document, 'click', function (event) {
        if (brandsOpen && !nav.contains(event.target)) {
          setBrandsOpen(false);
        }
      });

      addManagedListener(document, 'keydown', function (event) {
        if (event.key === 'Escape' && brandsOpen) {
          setBrandsOpen(false);
          brandToggle.focus();
        }
      });
    }

    addManagedListener(window, 'scroll', requestUpdate, { passive: true });
    addManagedListener(window, 'resize', function () {
      setHidden(false, performance.now());
      setBrandsOpen(false);
      resetScrollTracking(window.scrollY || 0);
      requestUpdate();
    }, { passive: true });

    if (desktopQuery.addEventListener) {
      addManagedListener(desktopQuery, 'change', function () {
        setHidden(false, performance.now());
        setBrandsOpen(false);
        resetScrollTracking(window.scrollY || 0);
        requestUpdate();
      });
    }

    resetScrollTracking(lastScrollY);
    updateHeaderNav(performance.now());
  }

  if (document.readyState === 'loading') {
    addManagedListener(document, 'DOMContentLoaded', initHavenHeader, { once: true });
  } else {
    initHavenHeader();
  }
})();